import React from "react"

const Alerts = ({ msg }) => (
    <div className='position-fixed animated slideInLeft'>
        
        <div className="" style={{ width: 'fit-content' }}>
            <link
                rel="stylesheet"
                href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"
            />
                <div className="alert-popup-new alert-popup" >
                    <strong >{msg}</strong>
                </div>
       
        </div>
    </div>
)

export default Alerts;